import { render } from "./NotFound.vue?vue&type=template&id=a03450ca&ts=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-runner/builds/syczUjMq/0/open-projects/ptm/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__